var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"clear"},[_c('div',{staticClass:"fixed-header"},[_c('Navbar')],1),_c('AppMain'),_c('div',[_c('Footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }